/**
 * Narrow selects for golf course page Supabase queries (avoid huge `about` HTML on first response).
 * Keep in sync with fields read under src/components/programmatic/golfCourse/.
 */
export const GOLF_COURSE_SELECT_NO_ABOUT = [
  'course_uid',
  'slug_course_name',
  'course_name',
  'course_country',
  'course_county',
  'course_city',
  'course_address',
  'course_postcode',
  'england_rank_gl',
  'ni_rank_gl',
  'usa_rank_gl',
  'scotland_rank_gl',
  'ireland_rank_gl',
  'wales_rank_gl',
  'county_rank',
  'number_holes',
  'par',
  'back_yardage',
  'slope',
  'course_style',
  'opened_date',
  'designer_original_1',
  'designer_original_2',
  'designer_contributor',
  'latitude',
  'longitude',
  'linked_golf_clubs',
  'club_website',
  'office_email',
  'office_phone',
  'collections',
  'last_edited_by',
  'last_edited_time',
  'visitor_policy',
].join(',');

/** golf_clubs fields used by GolfCourseMembershipSummary + visitor/membership UI */
export const GOLF_CLUB_SELECT_PAGE = [
  'club_uid',
  'club_name',
  'number_holes',
  'club_type',
  'fee_type',
  'adult_join_fee',
  'adult_annual_fee',
  'waiting_list',
  'membership_method',
  'membership_process',
].join(',');

/** club_course_mapping fields used on the course page */
export const CLUB_COURSE_MAPPING_SELECT = 'club_uid, sibling_courses, slug_course_name';
